
























import { DiscountParams } from '@/store/interfaces/discount';
import targetModal from './modals/target.vue';
import targetTable from '@/components/Discount/tables/targets.vue';
import { tCashbackParams } from '@/store/interfaces/cashback';
import {
  rulesDiscountAndCasbacks,
  tRulesDiscountAndCashbacks
} from '@/store/interfaces/discountAndCashbackRules';
import rulesDiscountAndCashbacks from '@/store/types/rulesDiscountAndCashbacks';
import { isCashbackCreateRoute } from '@/components/Cashback/routeValidation';
import Vue, { PropType } from 'vue';
import { mapGetters, mapMutations } from 'vuex';

const rulesNotAllowed: tRulesDiscountAndCashbacks[] = [
  'users',
  'transactions_amount',
  'transactions_count',
  'average_amount'
];

export default Vue.extend({
  name: 'TargetDiscound',
  components: {
    targetModal,
    targetTable,
  },
  props: {
    model: {
      type: Object as PropType<DiscountParams | tCashbackParams>,
      required: true,
    },
  },
  data: () => ({
    showModal: false,
    updateRule: {
      meta: [],
      data: {},
      rule: 'all',
    } as rulesDiscountAndCasbacks,
    ruleModalTitle: 'Regla de descuentos',
  }),
  mounted(): void {
    this.isCashbardRoute();

    if (this.syncedModel.rules.length > 0) {
      let rules = this.syncedModel.rules.map((rules) => rules.rule);

      if (this.syncedModel.kind === 'collective') {
        rules = rules.concat(rulesNotAllowed);
      }
      this.setRulesValidated(rules);
    }
  },
  computed: {
    syncedModel: {
      get(): DiscountParams | tCashbackParams {
        return this.model;
      },
      set(value: DiscountParams | tCashbackParams) {
        this.$emit('update:model', value);
      },
    },
    ...mapGetters({
      rulesValidated: `discountAndCashbackRules/${rulesDiscountAndCashbacks.getters.GET_RULES_VALIDATED}`,
    }),
  },
  methods: {
    ...mapMutations({
      setRulesValidated: `discountAndCashbackRules/${rulesDiscountAndCashbacks.mutations.SET_RULES_VALIDATED}`,
    }),
    isCashbardRoute(): void {
      if (isCashbackCreateRoute(this.$route)) {
        this.ruleModalTitle = 'Regla de cashback';
      }
    },

    newRule(rule: rulesDiscountAndCasbacks): void {
      if (
        this.syncedModel.rules.length > 0 &&
      this.syncedModel.rules[0].rule === 'all'
      ) {
        this.syncedModel.rules.splice(0, 1);
      }
      const positionOfRule = this.syncedModel.rules
        .map((r) => r.rule)
        .indexOf(rule.rule);

      if (positionOfRule !== -1) {
        this.syncedModel.rules[positionOfRule].meta = rule.meta;
        this.syncedModel.rules[positionOfRule].data = rule.data;
        return;
      }

      this.syncedModel.rules.push(rule);

      this.setRulesValidated(rule.rule);
    },
    updateSelectedFn(data: rulesDiscountAndCasbacks): void {
      this.updateRule = data;
      this.showModal = true;
    },
  },
  watch: {
    'syncedModel.kind': {
      deep: true,
      handler(val: string): void {
        if (val === 'collective') {
          const rulesAllowed: tRulesDiscountAndCashbacks[] = [
            'commerces',
            'branches',
            'commerce_kinds'
          ];
          const rulesToAdd: tRulesDiscountAndCashbacks[] = [];

          for (const rule of this.rulesValidated) {
            if (rulesAllowed.includes(rule)) rulesToAdd.push(rule);
          }

          this.setRulesValidated(rulesNotAllowed.concat(rulesToAdd));
        } else if (this.syncedModel.rules[0].rule !== 'all') {
          this.setRulesValidated(this.syncedModel.rules.map((rules) => rules.rule));
        } else {
          this.setRulesValidated([]);
        }
      },
    },
  },
});
